
import React from 'react'

import { Link } from 'react-router-dom';
import logo from '../images/logo.png'

const Footer = () => {

    return (
        <footer className="py-20 bg-secondary-200 px-4 md:px-6 lg:px-40">

            <div className="grid grid-cols-12">
                <div className="col-span-12 md:col-span-5 text-white px-3 mb-10">
                    <div className="flex items-center justify-center">
                       

                        <Link to="/contract" className='bg-secondary px-4 py-2 font-pmedium text-base text-black rounded'><i className='fa fa-cubes'></i> View BSC Contract</Link>
                        <div>

                        </div>

                    </div>
                    <p className="text-white font-pregular mt-5 text-base text-sm">
                        We are not just another earning platform, we are a revolution for you to grow your financial future through blockchain technology</p>

                </div>
                <div className="md:col-span-3"></div>

                <div className="col-span-12 md:col-span-4 text-white px-3">
                    <h3 className="font-pmedium text-primary">Follow us on Social Media</h3>


                    <div className="flex">
                        <a href="https://t.me/MarkManPro_OfficialChanel">
                        <div className="glow-circle mt-5 rounded-full mr-5 border-white text-base h-[40px] w-[40px] justify-center flex items-center">
                            <i className="fab fa-telegram text-secondary-100"></i>
                        </div>
                        </a>


                        <div className="glow-circle mt-5 rounded-full mr-5 border-white text-base h-[40px] w-[40px] justify-center flex items-center">
                            <i className="fab fa-twitter text-secondary-100"></i>
                        </div>




                    </div>

                </div>
            </div>

        </footer>
    )
}
export default Footer;